export default function ErrorPage() {
  return (
    <main className="grid min-h-full grid-cols-1 grid-rows-[1fr,auto,1fr] bg-white lg:grid-cols-[max(50%,36rem),1fr] h-screen">
      <header className="mx-auto w-full max-w-7xl px-6 pt-6 sm:pt-10 lg:col-span-2 lg:col-start-1 lg:row-start-1 lg:px-8">
        <a href="#">
          <span className="sr-only">Geerd</span>
          <img
            alt=""
            src="https://res.cloudinary.com/geerd/image/upload/v1699548762/easyclass/Logo_UM6P-ABS_Ocher_cezycu.png"
            className="w-auto h-8"
          />
        </a>
      </header>
      <main className="mx-auto w-full max-w-7xl px-6 py-24 sm:py-32 lg:col-span-2 lg:col-start-1 lg:row-start-2 lg:px-8">
        <div className="max-w-lg">
          <p className="text-base font-semibold leading-8 text-indigo-600">
            Error
          </p>
          <h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">
            Something wrong happened
          </h1>
          <p className="mt-6 text-base leading-7 text-gray-600">
            We apologize for the inconvenience. If the problem persists, contact
            our support team.
          </p>
          <div className="mt-10">
            <a
              href=""
              className="text-sm font-semibold leading-7 text-indigo-600"
            >
              <span aria-hidden="true">&larr;</span> Back to home
            </a>
          </div>
        </div>
      </main>
      <footer className="self-end lg:col-span-2 lg:col-start-1 lg:row-start-3">
        <div className="border-t border-gray-100 bg-gray-50 py-10">
          <nav className="mx-auto flex w-full max-w-7xl items-center gap-x-4 px-6 text-sm leading-7 text-gray-600 lg:px-8">
            <a href="#">Contact support</a>
            <svg
              viewBox="0 0 2 2"
              aria-hidden="true"
              className="h-0.5 w-0.5 fill-gray-300"
            >
              <circle r={1} cx={1} cy={1} />
            </svg>
          </nav>
        </div>
      </footer>
      <div className="hidden lg:relative lg:col-start-2 lg:row-start-1 lg:row-end-4 lg:block">
        <img
          alt=""
          src="https://res.cloudinary.com/geerd/image/upload/t_cover/v1637068252/geerd/um6p_pergola_xrvwrr_xn52fa.webp"
          className="absolute inset-0 h-full w-full object-cover"
        />
      </div>
    </main>
  );
}
